<script>
  import { SPRITES, TYPE_SPRITE_MAP } from "../../constants/sprites";
  import ComponentTiled from "./ComponentTiled.svelte";
  export let card, width, onclick, draggable;
</script>

<ComponentTiled
  {...$$props}
  {width}
  {onclick}
  sprite={SPRITES[TYPE_SPRITE_MAP[card.type]]}
  offset={card.offset}
  borderRadius={15}
  className="{onclick || draggable ? 'hover' : ''} shadow-md"
/>

<style>
  :global(.card) {
    cursor: pointer;
  }
  :global(.card:hover) {
    filter: brightness(1.2);
  }
</style>
